import { render, staticRenderFns } from "./AttachCoordinatorsModal.vue?vue&type=template&id=4860f385&scoped=true&"
import script from "./AttachCoordinatorsModal.vue?vue&type=script&lang=js&"
export * from "./AttachCoordinatorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860f385",
  null
  
)

export default component.exports